import React, { type ReactNode } from 'react';
import type ApolloClient from 'apollo-client';
import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { ForgeModalDeprecationMessage } from './ForgeModalDeprecationMessage';
import { type ModalExtension } from './util';
import { getAkModalWidth } from '../utils';
import { type Extension } from '../web-client';

const styles = cssMap({
	modalWrapper: {
		paddingBottom: token('space.300'),
	},
});

interface ForgeExtensionPointModalProps {
	children: ReactNode;
	modalExtension: ModalExtension;
	shouldShowFCFModalDeprecationMessage?: boolean;
	client?: ApolloClient<any>;
	extension?: Extension;
}

export const ForgeExtensionPointModal = ({
	children,
	modalExtension,
	shouldShowFCFModalDeprecationMessage,
	client,
	extension,
}: ForgeExtensionPointModalProps) => {
	const {
		closeModalExtension,
		title,
		modalWidth,
		shouldCloseOnOverlayClick,
		shouldCloseOnEscapePress,
	} = modalExtension;

	const akModalWidth = modalWidth ? getAkModalWidth(modalWidth) : undefined;

	return (
		<Modal
			shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
			shouldCloseOnEscapePress={shouldCloseOnEscapePress}
			onClose={closeModalExtension}
			width={akModalWidth}
		>
			<ModalHeader>
				<ModalTitle>{title}</ModalTitle>
				<IconButton
					appearance="subtle"
					icon={CrossIcon}
					label="Close Modal"
					onClick={closeModalExtension}
				/>
			</ModalHeader>
			<ModalBody>
				{shouldShowFCFModalDeprecationMessage && extension && client ? (
					<Stack space="space.200">
						<ForgeModalDeprecationMessage client={client} extension={extension} />
						<Box xcss={styles.modalWrapper}>{children}</Box>
					</Stack>
				) : (
					<Box xcss={styles.modalWrapper}>{children}</Box>
				)}
			</ModalBody>
		</Modal>
	);
};
